/*
 * @Author: Alex Sorafumo
 * @Date:   2017-03-29 09:24:29
 * @Last Modified by:   Alex Sorafumo
 * @Last Modified time: 2017-05-05 10:46:34
 */

import { Component, ElementRef, Input, Renderer2, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { BaseWidgetComponent } from '../../../shared/base.component';

@Component({
    selector: 'progress-circle',
    template: `<div #main [class]="'radial-progress' + (klass ? ' ' + klass : '')" widget>
    <svg viewBox="0 0 120 120">
        <circle cx="60" cy="60" r="54" fill="none" [style.stroke]="bg" stroke-width="8" />
        <circle cx="60" cy="60" r="54" fill="none" [style.stroke]="color" stroke-width="8"
            stroke-dasharray="339.292" [style.stroke-dashoffset]="339.292 * (1 - progress / 1000)" />
    </svg>
</div>`,
    styles: [`.radial-progress{margin:1em}svg{height:8em;width:8em;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}circle{-webkit-transition:stroke-dashoffset .2s;transition:stroke-dashoffset .2s}`],
})
export class ProgressCircleComponent extends BaseWidgetComponent implements OnChanges {
    @Input() public progress = 0; // Number between 0 and 1000
    @Input() public bg = '#CFD8DC';
    @Input() public color = '#2196F3';
    @Input() public innerColor = '#2196F3';

    @ViewChild('main') private main: ElementRef;
    @ViewChild('maskfull') private mask_full: ElementRef;
    @ViewChild('full') private full: ElementRef;
    @ViewChild('half') private half: ElementRef;
    @ViewChild('fix') private fix: ElementRef;
    @ViewChild('inner') private inner: ElementRef;

    constructor(private renderer: Renderer2) {
        super();
    }

    public ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (changes.progress) {
            this.update();
        }

        if (changes.color || changes.innerColor) {
            this.changeColor();
        }
    }

    public update() {
        this.progress = Math.round(this.progress);
        if (this.progress < 0) {
            this.progress = 0;
        } else if (this.progress > 1000) {
            this.progress = 1000;
        }
        if (this.main) {
            this.renderer.setAttribute(this.main.nativeElement, 'data-progress', this.progress.toString());
        }
        if (this.full) {
            this.renderer.setStyle(this.full.nativeElement, 'transform', `rotate(${180 / 1000 * this.progress}deg)`);
        }
        if (this.mask_full) {
            const transform = `translate(-50%, -50%)`;
            const rotate = `${transform} rotate(${180 + 180 / 1000 * this.progress}deg)`;
            this.renderer.setStyle(this.mask_full.nativeElement, 'transform', rotate);
        }
        if (this.fix) {
            this.renderer.setStyle(this.fix.nativeElement, 'transform', `rotate(${180 / 1000 * this.progress * 2}deg)`);
        }
    }

    public changeColor() {
        if (this.full && this.fix && this.half && this.inner && this.main && this.mask_full) {
            this.renderer.setStyle(this.full.nativeElement, 'background-color', this.color);
            this.renderer.setStyle(this.half.nativeElement, 'background-color', this.color);
            this.renderer.setStyle(this.fix.nativeElement, 'background-color', this.color);
            this.renderer.setStyle(this.inner.nativeElement, 'background-color', this.innerColor);
            this.renderer.setStyle(this.main.nativeElement, 'background-color', this.bg);
            this.renderer.setStyle(this.mask_full.nativeElement, 'background-color', this.bg);
        } else {
            this.timeout('color', () => {
                this.changeColor();
            }, 200);
        }
    }
}
